import ScalarIconBookOpenText_vue_vue_type_script_setup_true_lang_default from "./ScalarIconBookOpenText.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconBookOpenText.vue
var ScalarIconBookOpenText_default = ScalarIconBookOpenText_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconBookOpenText_default as default };

//# sourceMappingURL=ScalarIconBookOpenText.js.map